import React from 'react';
import { IconTileStyled } from './icon-tile.component.style';
export var IconTile = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, children = _a.children;
    return (React.createElement(IconTileStyled, { variant: variant, "aria-hidden": "true" }, children));
};
